var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-page"},[_c('el-empty',{attrs:{"description":_vm.description,"image-size":260}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.onIndex}},[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }